.LocalePickerPanel {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: #111111;

    .flagsContainer {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
    }

    .flagButton {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        width: 40px;
        height: 40px;
        border: 2px solid transparent;
        background: transparent;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            border-color: rgba(255, 255, 255, 0.4);
            transform: scale(1.1);
        }

        &.isSelected {
            border-color: rgba(255, 255, 255, 0.8);
            box-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
        }
    }

    .flag {
        width: 100% !important;
        height: 100% !important;
        border-radius: 50%;
    }
}
